var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-full"},[_vm._t("content",function(){return [_c('p',{staticClass:"white-text font-thin leading-normal py-12 capitalize",class:[
        'text-2xl ',
        'text-center ',
        'lg:text-4xl'
      ]},[_vm._v(" "+_vm._s(_vm.content)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }